import { render, staticRenderFns } from "./extraElement.vue?vue&type=template&id=174f6d0c&scoped=true&"
import script from "./extraElement.vue?vue&type=script&lang=js&"
export * from "./extraElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174f6d0c",
  null
  
)

export default component.exports